var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 309.19,
    x2: 425.47,
    y1: 363.92,
    y2: 363.92
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Not_Found",
    "data-name": "Not Found"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m425.47 102v293.31a17.75 17.75 0 0 1 -17.75 17.74h-312a17.74 17.74 0 0 1 -17.72-17.74v-293.31a17.74 17.74 0 0 1 17.69-17.74h312a17.75 17.75 0 0 1 17.78 17.74z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.47 321.78v73.54a17.75 17.75 0 0 1 -17.75 17.74h-97.07c-9.63-50.89 29.61-98.27 81.52-98.27a82.27 82.27 0 0 1 33.3 6.99z",
    fill: "url(#linear-gradient)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.72 416.05h-312a20.76 20.76 0 0 1 -20.72-20.74v-293.31a20.76 20.76 0 0 1 20.69-20.74h312a20.77 20.77 0 0 1 20.78 20.74v293.31a20.77 20.77 0 0 1 -20.75 20.74zm-312.03-328.79a14.75 14.75 0 0 0 -14.69 14.74v293.31a14.75 14.75 0 0 0 14.74 14.74h312a14.76 14.76 0 0 0 14.75-14.74v-293.31a14.76 14.76 0 0 0 -14.75-14.74z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.47 102v21.78h-347.47v-21.78a17.74 17.74 0 0 1 17.69-17.74h312a17.75 17.75 0 0 1 17.78 17.74z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.68,
    cy: 104.02,
    fill: "#f5f5f5",
    r: 7.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.76,
    cy: 104.02,
    fill: "#f5f5f5",
    r: 7.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.12,
    cy: 241.96,
    fill: "#dee1ec",
    r: 99.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273 389.81h-37.76a10.15 10.15 0 0 1 0-20.3h37.76a10.15 10.15 0 0 1 0 20.3z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.17,
    cy: 397.73,
    fill: "#f5f5f5",
    r: 67.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.17 468.67a70.95 70.95 0 1 1 70.94-70.94 71 71 0 0 1 -70.94 70.94zm0-135.89a64.95 64.95 0 1 0 64.94 65 65 65 0 0 0 -64.94-65z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.6 265.85a48.25 48.25 0 0 1 20-38.11 16.33 16.33 0 1 0 -25.82-14.27h-21.04a37.39 37.39 0 1 1 59.2 31.36 27.19 27.19 0 0 0 -11.27 21z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.33 285.68h21.16v21.16h-21.16z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.84 404.29a30.53 30.53 0 1 0 -10 10c6.27 10.66 11.58 15.33 20.63 24.38a48.6 48.6 0 0 0 13.61-14c-8.89-8.77-13.61-14.12-24.24-20.38zm-15-5a15.52 15.52 0 1 1 0-22 15.53 15.53 0 0 1 -.05 22z",
    fill: "#e1830e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.15 459.46h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.17 444.47h-6v-6h6zm0-16h-6v-5.55h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e6175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m432.07 65.43h18.88v6h-18.88z",
    transform: "matrix(.707 -.707 .707 .707 80.96 332.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.26 46.33h6v18.88h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.24 86.53h18.88v6h-18.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.31 428.9a9.43 9.43 0 1 1 9.42-9.42 9.44 9.44 0 0 1 -9.42 9.42zm0-12.85a3.43 3.43 0 1 0 3.42 3.43 3.44 3.44 0 0 0 -3.42-3.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.1 462.24a12.92 12.92 0 1 1 12.9-12.92 12.93 12.93 0 0 1 -12.9 12.92zm0-19.83a6.92 6.92 0 1 0 6.91 6.91 6.92 6.92 0 0 0 -6.91-6.91z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m193.17 403.84h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6z",
    fill: "#a9afc4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.7e7115bb5f01b667199acb332b5f27d4.svg";
export { ForwardRef as ReactComponent };